var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.093 13.374.626-3.98h-3.858V6.809c0-1.088.538-2.152 2.26-2.152h1.78v-3.39A21.563 21.563 0 0 0 14.769 1C11.593 1 9.52 2.909 9.52 6.36v3.035H6v3.98h3.52V23h4.34v-9.626h3.233Z",
    fill: "currentColor"
  })));
};

export default SvgFacebook;